import { ToastContextProvider } from 'components/alert/ToastContext';
import { PrimeReactProvider } from 'primereact/api';
import "primereact/resources/primereact.min.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import AuthProvider from 'provider/AuthProvider';
import './App.scss';
import AppRoutes from './AppRoutes';
import { LoadingContextProvider } from 'provider/LoadingProvider';
import { FilterProvider } from 'contexts/FilterContext';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers';

function App() {
    return (
        <PrimeReactProvider>
            <AuthProvider>

                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt-br">
                    <LoadingContextProvider>
                        <ToastContextProvider>
                            <FilterProvider>
                                <AppRoutes />
                            </FilterProvider>
                        </ToastContextProvider>
                    </LoadingContextProvider>
                </LocalizationProvider>
            </AuthProvider>
        </PrimeReactProvider>
    )
}

export default App;